import { defineAsyncComponent } from 'vue'

export const ModalOpenInBrowser = defineAsyncComponent(() => import('../ModalOpenInBrowser/ModalOpenInBrowser.vue'))
